export default __webpack_public_path__ + "static/media/managebe.df709d34.jpeg";